/*global _ */
import ComplexComponentMixin from './complex'

export default {
  mixins: [ComplexComponentMixin],
  data: () => ({
    defaultComponent: null,
    defaultComponents: [],
  }),
  computed: {
    componentName() {
      return this.$$s('component') || this.defaultComponent
    },
    componentNames() {
      return this.$$s('components') || this.defaultComponents
    },
  },
  methods: {
    getPageClasses() {
      return ['re-page', this.pageClasses, ...this.getPageExtraClasses()]
    },
    getPageExtraClasses() {
      return []
    }
  },
}

